import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ObservationGroup } from 'app/mdm/lib/observation-group/observation-group';
import { SearchHttpParams, SearchResult } from '@heda/core-util';
import { ObservationGroupSearchParams } from 'app/mdm/lib/observation-group/observation-group-search-params';

@Injectable({ providedIn: 'root' })
export class ObservationGroupService {
  protected baseUrl = `${environment.mdmApi}/observation-groups`;

  constructor(protected http: HttpClient) {}

  public search(params: ObservationGroupSearchParams): Observable<SearchResult<ObservationGroup>> {
    return this.http.get<SearchResult<ObservationGroup>>(this.baseUrl, { params: SearchHttpParams.build(params) });
  }

  public load(id: number): Observable<ObservationGroup> {
    return this.http.get<ObservationGroup>(`${this.baseUrl}/${id}`);
  }
}
